
const baseURL = 'https://www.online-examination.com:8473/';
// const baseURL = 'https://admin.online-examination.com/';
// const baseURL = 'https://47.99.204.31:8060';
// const baseURL = 'https://192.168.2.11:8473/';
// const baseURL = 'https://www.jobs-interviews.cn/';
// const baseURL = "https://192.168.1.35:8443/";
export default baseURL;
